export const emotionEnum = Object.freeze({
    POZITIVE: 1,
    NEGATIVE: 2,
    NEUTRAL: 3
});